import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChoiceDialog } from 'shared/dialogs/choice';
import { TimeslotEffectOptions } from 'shared/types/timeslot';

export type UpdateTaskRepeatTimeslotDialogProps = {
  open: boolean;
  onSubmit: (timeslotEffect: TimeslotEffectOptions) => void;
};

// Binds the repeating-task copy onto the shared occurrence prompt — the same question the
// calendar-event popup asks, so neither owns the markup.
export const UpdateTaskRepeatTimeslotDialog: React.FC<
  UpdateTaskRepeatTimeslotDialogProps
> = ({ open, onSubmit }) => {
  const { t } = useTranslation();

  const onCancel = () => onSubmit(TimeslotEffectOptions.Cancel);
  const onSingle = () => onSubmit(TimeslotEffectOptions.SingleOccurrence);
  const onAll = () => onSubmit(TimeslotEffectOptions.AllOccurrences);

  return (
    <ChoiceDialog
      open={open}
      title={t('forms.update-habit-repeating-timeslot.title')}
      message={t('forms.update-habit-repeating-timeslot.description')}
      primaryLabel={t(
        'forms.update-habit-repeating-timeslot.buttons.single.label',
      )}
      secondaryLabel={t(
        'forms.update-habit-repeating-timeslot.buttons.all.label',
      )}
      cancelLabel={t(
        'forms.update-habit-repeating-timeslot.buttons.cancel.label',
      )}
      onPrimary={onSingle}
      onSecondary={onAll}
      onCancel={onCancel}
    />
  );
};
